export const DEFAULT_MAP_OPTIONS_DATA_CONSTANT = {
  zoom: 5,
  animate: true,
  attributionControl: false,
  center: [-0.263671, 118.564453],
  fadeAnimation: true,
  maxZoom: 22,
  maxBounds: [
    [-16.59408141271846, 63.25195312500001],
    [16.088042220148818, 163.83300781250003],
  ],
  maxBoundsViscosity: 1.0,
  minZoom: 5,
  keyboard: true,
  keyboardPanDelta: 20,
  trackResize: true,
  scrollWheelZoom: true,
  zoomControl: false,
  zoomAnimation: true,
  doubleClickZoom: false,
  zoomSnap: 1,
  style: { width: '100%', height: '100vh' },
  preferCanvas: true,
};
